<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Add Road Tax'">
        <form v-on:submit.prevent="doSubmitRoadTax">
            <label>Road Tax No. *</label>
            <b-form-input :required="true" for-input="billNumber" type="text" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Number" v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>
            <label>Expired Date *</label>
            <b-form-datepicker
              id="yearTax"
              name="yearTax"
              :required="true"
              v-model="roadTaxDate"
              v-validate="modelValidations.yearTax"
              v-bind:class="errors.has('yearTax') ? 'is-invalid':''"
              locale="en-US"
              placeholder="No Date Selected"
            ></b-form-datepicker>
            <br>
            <!-- <label>Road Tax Date *</label>
            <b-form-datepicker
              id="yearTax"
              name="yearTax"
              :required="true"
              v-model="model.options[0].value"
              v-validate="modelValidations.yearTax"
              v-bind:class="errors.has('yearTax') ? 'is-invalid':''"
              locale="en-US"
              placeholder="No Date Selected"
            ></b-form-datepicker>
            <br> -->
            <label>Amount *</label>
            <b-form-input :required="true" for-input="amount" type="text" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>
            <label>Bill Photo *</label>
            <div class="expander">
              <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill')" v-model="model.photoBill">
                <div class="input-group">
                  <div class="custom-file">
                    <b-form-input type="file" class="custom-file-input" ref="photoBill" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill" v-validate="modelValidations.photoBill" :error="errors.first('photoBill')" data-vv-as="photoBill"/>
                    <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill !== null ? model.photoBill.name : 'Choose file'}}</label>
                  </div>
                  <div v-if="model.photoBill !== null" class="input-group-append">
                    <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                  </div>
                </div>
              </b-form-file>
            </div><br>
            <label>Note *</label>
            <b-form-input for-input="note" :required="true" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-model="model.note" data-vv-as="note"/><br>
            <!-- <label>Due Date *</label>
            <b-form-datepicker
              id="dueDate"
              name="dueDate"
              v-model="model.dueDate"
              v-validate="modelValidations.dueDate"
              v-bind:class="errors.has('dueDate') ? 'is-invalid':''"
              locale="en-US"
              :readonly="readonly"
            ></b-form-datepicker>
            <br> -->
            <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Submit </b-button>
            <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
        },
        type: null,
        model: {
          uuid: null,
          amount: null,
          billNumber: null,
          photo: null,
          photoBill: null,
          note: null,
          dueDate: null,
          vehicle: null,
          type: "Road Tax",
          options: [{
            name: "RoadTax",
            value: null
          }]
        },
        roadTaxDate: null,
        modelValidations: {
          yearTax: {
            required: true
          },
          dueDate: {
            required: true
          },
          billNumber: {
            required: true
          },
          amount: {
            required: true
          }
        },
        formatted: '',
        selected: '',
        dateState: 'readonly'
      }
    },
    computed: {
      readonly() {
        return this.dateState === 'readonly'
      }
    },
    methods: {
      onContext(ctx) {
        this.selected = ctx.selectedYMD
        if(this.selected != ''){
          const now = new Date(this.selected)
          const d = this.$moment(this.selected).add('1', 'y')
          this.model.dueDate = new Date(d)
        }
      },
      // doSubmitRoadTax() {
      //   this.$validator.validateAll().then(res => {
      //     if (res) {
      //       this.isLoading = true
      //       this.model.vehicle = this.$route.params.uuid
      //       this.$http.post(this.apiUrl.vehicleBillInfo, this.model).then(response => {
      //           this.isLoading = false
      //           this.$store.dispatch('notification/success', 'RoadTax successfully added.')
      //           this.hideModal()
      //           this.resetData()
      //           this.$emit('getRoadTaxBill')
      //       }).catch(error => {
      //           this.isLoading = false
      //           this.$store.dispatch('notification/error', error)
      //       })
      //     }
      //   })
      // },
      doSubmitRoadTax() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            this.model.vehicle = this.$route.params.uuid

            let form = new FormData();
            form.append('vehicle',this.model.vehicle)
            form.append('dueDate',this.roadTaxDate)
            // form.append('options', JSON.stringify(this.model.options))
            form.append('type',this.model.type)
            form.append('billNumber',this.model.billNumber)
            form.append('amount',this.model.amount)
            if (this.model.photoBill !== null) {
              form.append('photoBill1', this.model.photoBill, this.model.photoBill.name)
            }
            form.append('note',this.model.note)
            this.$http.post(this.apiUrl.vehicleBillInfo, form).then(() => {
              this.isLoading = false
              this.$store.dispatch('notification/success', 'Road tax data successfully added.')
              this.$emit('getRoadTaxBill')
              this.hideModal()
              this.resetData()
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      onFileSelectedPhoto (event) {
        this.model.photo = event.target.files[0]
      },
      clearImagePhoto () {
        this.$refs.photoBill.value = ''
        this.model.photoBill = null
      },
      resetData () {
        this.model.uuid = null
        this.roadTaxDate = null
        this.model.note = null
        this.model.billNumber = null
        this.model.amount = null
        this.$validator.reset()
      },
      showModal() {
        this.model.options.value = null
        this.roadTaxDate = null
        this.model.uuid = null
        this.model.note = null
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>